import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logSponsoredListClickedParams = {
  carousel_index?: number;
  carousel_length?: number;
  description?: string;
  location: CardLocation;
  page_slug: string;
};

/**
 * User click a sponsored list card.
 * @param params - Attributes to log with the amplitude event
 * @param params.carousel_index - Position of card in the carousel user click on (starting with 0)
 * @param params.carousel_length - Total number of cards in the carousel.
 * @param params.description - Description of sponsored list clicked by user
 * @param params.location - The location of the sponsored list carousel
 * @param params.page_slug - Page slug of sponsored list clicked by user
 */
const logSponsoredListClicked = (
  { carousel_index, carousel_length, description, location, page_slug }: logSponsoredListClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'sponsored list clicked',
    { 'carousel index': carousel_index, 'carousel length': carousel_length, description, location, 'page slug': page_slug },
    callback
  );
};

export default logSponsoredListClicked;
